import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`

    /* Course Grid */
    .course-grid-area {
        padding: 70px 0;
        .course-items {
            .course-item {
                border: 1px solid ${colors.border1};
                border-radius : 5px;
                transition : all 0.2s ease;
                overflow : hidden;
                margin-bottom: 30px;

                .course-image {
                    width              : 100%;
                    height             : 240px;
                    background-size    : cover;
                    background-position: center;
                    background-repeat  : no-repeat;
                    border-radius : 5px 5px 0 0;
                    position: relative;

                    .author-img {
                        position: absolute;
                        left    : 20px;
                        bottom  : 20px;

                        img {
                            max-width: 40px;
                            border-radius : 50%;
                            margin-right: 5px;
                        }

                        .title {
                            background: #ffffff;
                            padding   : 3px 8px;
                            border-radius : 5px;

                            p {
                                font-size    : 12px;
                                color        : ${colors.black1};
                                font-weight  : 500;
                                margin-bottom: -4px;
                            }

                            span {
                                font-size  : 11px;
                                color      : ${colors.text3};
                                font-weight: 500;
                            }
                        }

                    }

                    .course-price {
                        p {
                            font-size  : 16px;
                            color      : #ffffff;
                            background : ${colors.bg1};
                            position   : absolute;
                            right      : 20px;
                            bottom     : 20px;
                            padding    : 8px 10px;
                            font-weight: 500;
                            border-radius : 5px;
                        }
                    }

                    @media(max-width: 767px) {
                        height: 185px;
                    }
                }

                .course-content {
                    background: #fff;
                    padding   : 20px 25px;

                    h6.heading {
                        a {
                            color        : ${colors.black1};
                            font-weight  : 600;
                            display      : inline-block;
                            margin-bottom: 12px;

                            &:hover {
                                color: ${colors.red};
                            }
                        }
                    }

                    p.desc {
                        font-size     : 14px;
                        color         : ${colors.text3};
                        line-height   : 25px;
                        border-bottom : 1px solid ${colors.border1};
                        padding-bottom: 10px;
                        margin-bottom : 12px;
                    }

                    .course-face {

                        .duration,
                        .student {
                            p {
                                font-size: 13px;
                                color    : ${colors.text3};

                                i {
                                    font-size     : 16px;
                                    color         : ${colors.red};
                                    vertical-align: text-bottom;
                                    margin-right  : 3px;
                                }
                            }
                        }

                        .rating {
                            ul {
                                li {
                                    margin-right: 0;

                                    i {
                                        font-size: 14px;
                                        color    : ${colors.yellow};
                                    }

                                    &:last-child {
                                        font-size: 13px;
                                        color    : ${colors.text3};
                                    }
                                }
                            }
                        }
                    }

                    .course-actions {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .btn {
                            font-size: 12px;
                            font-weight: 500;
                        }
                    }
                }

                &:hover {
                    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.07);
                }
            }
        }

        @media(max-width: 767px) {
            padding: 40px 0 30px;
        }
    }

    /* Course List */
    .course-list-area {
        padding: 70px 0;
        .course-items2 {
                .course-item {
                    border-radius : 5px;
                    transition : all 0.2s ease;
                    overflow : hidden;
                    box-shadow: 0 8px 20px 5px rgba(0,0,0,0.07);
                    margin-bottom: 30px;

                    .course-content {
                        background: #fff;
                        padding   : 20px 25px;

                        h6.heading {
                        color        : ${colors.black1};
                        font-weight  : 600;
                        display      : inline-block;
                            margin-bottom: 15px;
                        }

                        .course-price {
                            p {
                                font-size  : 16px;
                                color      : ${colors.red};
                                font-weight: 600;
                                margin-bottom: 10px;
                            }
                        }

                        p.desc {
                            font-size     : 14px;
                            color         : ${colors.text3};
                        line-height   : 25px;
                        margin-bottom : 15px;
                    }

                    .course-meta {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 10px 15px;
                        margin-bottom: 15px;
                        span {
                            font-size: 13px;
                            color: ${colors.text3};
                            display: inline-flex;
                            align-items: center;
                            i {
                                font-size: 16px;
                                color: ${colors.red};
                                margin-right: 6px;
                            }
                        }
                    }

                    .course-actions {
                        display: flex;
                        align-items: center;
                        gap: 12px;

                        .btn {
                            font-size: 12px;
                            font-weight: 500;
                            padding: 6px 12px;
                        }

                        .btn-link {
                            padding: 0;
                        }
                    }

                    .course-foot {
                        margin-top: 15px;
                        padding-top: 12px;
                        border-top: 1px solid ${colors.border1};
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 14px;
                        flex-wrap: wrap;

                        .recent-applicants {
                            flex: 1 1 160px;
                            display: flex;
                            align-items: center;
                            min-height: 34px;
                            min-width: 120px;
                            gap: 6px;

                            .spinner-border {
                                width: 18px;
                                height: 18px;
                                color: ${colors.red};
                                margin-right: 6px;
                            }

                            .avatar-group {
                                display: flex;
                                align-items: center;
                                gap: 6px;
                                flex-direction: row;
                                direction: ltr;
                                .avatar-item {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                    background: rgba(17, 182, 122, 0.12);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 12px;
                                    font-weight: 600;
                                    color: ${colors.red};
                                    text-transform: uppercase;
                                    border: 1px solid rgba(17, 182, 122, 0.2);
                                    overflow: hidden;
                                    position: relative;
                                    backdrop-filter: blur(2px);

                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        border-radius: 50%;
                                        display: block;
                                    }

                                    span {
                                        display: inline-flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 100%;
                                        height: 100%;
                                        background: transparent;
                                        color: inherit;
                                    }

                                    &.counter {
                                        background: rgba(24, 43, 73, 0.08);
                                        border-color: rgba(24, 43, 73, 0.1);
                                        color: ${colors.black1};
                                    }

                                    &.no-image {
                                        background: linear-gradient(90deg, #11B67A 0%, #009444 100%);
                                        color: #ffffff;
                                        border-color: transparent;

                                        span {
                                            color: #ffffff;
                                            font-weight: 700;
                                            letter-spacing: 0.02em;
                                        }
                                    }
                                }
                            }
                        }

                        .recent-count {
                            font-size: 12px;
                            color: ${colors.text3};
                            font-weight: 600;
                            white-space: nowrap;
                        }
                    }

                    .details-btn {
                        font-size : 13px;
                        color : ${colors.red};
                        border : 1px solid ${colors.border3};
                        padding: 7px 15px;
                        border-radius: 5px;
                        font-weight: 500;
                        &:hover {
                            color : #ffffff;
                            background : ${colors.red_bg};
                            border-color : ${colors.red};
                        }
                    }
                }

                &:hover {
                    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
                }

                @media(max-width: 991px) {
                    display : block !important;
                }

                &.loading-state,
                &.error-state,
                &.empty-state {
                    background: #fff;
                    padding: 25px;
                    text-align: center;
                    box-shadow: none;
                    border: 1px solid ${colors.border1};
                    p {
                        margin: 0;
                        color: ${colors.text3};
                        font-size: 14px;
                    }
                }
            }
        }

        @media(max-width: 767px) {
            padding: 40px 0 30px;
        }
    }

    /* Course Details */
}

.course-details-area {
    padding: 70px 0;
}

.course-details-area .course-details-wrapper {
    row-gap: 30px;
}

.course-details-area .detail-card {
    background: #ffffff;
    border: 1px solid ${colors.border1};
    border-radius: 10px;
    padding: 30px;
    margin-bottom: 30px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

.course-details-area .course-summary-card .summary-header {
    margin-bottom: 25px;
}

.course-details-area .course-summary-card .summary-tag {
    display: inline-block;
    background: ${colors.red_bg};
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 6px 14px;
    border-radius: 50px;
    margin-bottom: 15px;
}

.course-details-area .course-summary-card h2 {
    font-size: 30px;
    color: ${colors.black1};
    font-weight: 600;
    margin-bottom: 10px;
    line-height: 1.4;
}

.course-details-area .course-summary-card .summary-subtitle {
    font-size: 16px;
    color: ${colors.text3};
    margin-bottom: 0;
}

.course-details-area .course-summary-card .summary-meta {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 20px;
}

.course-details-area .course-summary-card .summary-meta-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.course-details-area .course-summary-card .summary-meta-item .icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: rgba(18, 173, 91, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.red};
    font-size: 18px;
}

.course-details-area .course-summary-card .meta-label {
    font-size: 12px;
    text-transform: uppercase;
    color: ${colors.text3};
    letter-spacing: 0.5px;
}

.course-details-area .course-summary-card .meta-value {
    display: block;
    font-size: 14px;
    color: ${colors.black1};
    font-weight: 600;
}

.course-details-area .detail-card h4,
.course-details-area .detail-card h5 {
    color: ${colors.black1};
    font-weight: 600;
    margin-bottom: 18px;
    position: relative;
    padding-bottom: 10px;
}

.course-details-area .detail-card h4:before,
.course-details-area .detail-card h5:before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 48px;
    height: 2px;
    background: ${colors.red};
}

.course-details-area .detail-card p {
    font-size: 15px;
    color: ${colors.text3};
    line-height: 26px;
    margin-bottom: 0;
}

.course-details-area .detail-card .program-details-frame {
    width: 100%;
    height: 600px;
    border: none;
    display: block;
}

.course-details-area .detail-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.course-details-area .detail-list li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: ${colors.text2};
    padding: 14px 0;
    border-bottom: 1px solid ${colors.border1};
}

.course-details-area .detail-list li:last-child {
    border-bottom: none;
}

.course-details-area .detail-list li i {
    font-size: 18px;
    color: ${colors.red};
    margin-right: 12px;
}

.course-details-area .detail-list li span {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 500;
    color: ${colors.black1};
}

.course-details-area .detail-list li strong {
    color: ${colors.text3};
    font-weight: 600;
    margin-left: 12px;
}

.course-details-area .detail-list.compact li {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.course-details-area .detail-list.compact li strong {
    margin-left: 0;
}

.course-details-area .scholarship-note {
    margin-top: 18px;
    padding: 14px 16px;
    border-radius: 8px;
    background: rgba(18, 173, 91, 0.08);
    color: ${colors.black1};
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.course-details-area .scholarship-note i {
    color: ${colors.red};
    font-size: 18px;
}

.course-details-area .actions-card {
    background: linear-gradient(135deg, rgba(18,173,91,0.08), rgba(18,173,91,0.02));
}

.course-details-area .actions-card h5 {
    padding-bottom: 0;
    margin-bottom: 6px;
}

.course-details-area .actions-card h5:before {
    display: none;
}

.course-details-area .cta-text p {
    margin-bottom: 0;
    color: ${colors.text3};
}

.course-details-area .course-details-sidebar {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.course-details-area .course-details-sidebar .sidebar-card {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid ${colors.border1};
    padding: 24px;
    box-shadow: 0 12px 30px rgba(0,0,0,0.08);
}

.course-details-area .course-details-sidebar .pricing-card .label {
    font-size: 12px;
    text-transform: uppercase;
    color: ${colors.text3};
    letter-spacing: 1px;
}

.course-details-area .course-details-sidebar .pricing-card .price {
    font-size: 24px;
    font-weight: 700;
    color: ${colors.red};
    margin: 10px 0 0;
}

.course-details-area .course-details-sidebar .info-card h5 {
    font-size: 18px;
    font-weight: 600;
    color: ${colors.black1};
    margin-bottom: 12px;
}

.course-details-area .course-details-sidebar .info-card p {
    font-size: 14px;
    color: ${colors.text3};
    line-height: 24px;
}

@media(max-width: 991px) {
    .course-details-area {
        padding: 40px 0;
    }
    .course-details-area .detail-card {
        padding: 24px;
    }
}

@media(max-width: 575px) {
    .course-details-area .course-summary-card h2 {
        font-size: 24px;
    }
    .course-details-area .course-summary-card .summary-meta {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    }
}
    .course-details-area {
        padding : 70px 0 78px;
        .course-details-top {
            .heading {
                h4 {
                    color : ${colors.black1};
                    font-weight: 600;
                    line-height: 35px;
                    margin-bottom: 25px;

                    @media(max-width: 575px) {
                        font-size : 20px;
                    }
                }
            }
            .course-top-overview {
                margin-bottom : 25px;
                .overviews {
                    .author {
                        margin-right : 20px;
                        padding-right : 20px;
                        margin-top: -3px;
                        border-right : 1px solid ${colors.border3};
                        img {
                            float : left;
                            max-width: 50px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }
                        .author-name {
                            float : left;
                            margin-top: 3px;
                            h6 {
                                color : ${colors.black2};
                                font-weight: 600;
                                text-transform: uppercase;
                                margin-bottom: 5px;

                                @media(max-width: 767px) {
                                    font-size : 14px;
                                }
                            }
                            p {
                                font-size : 15px;
                                color : ${colors.text3};
                                font-weight: 500;

                                @media(max-width: 767px) {
                                    font-size : 14px;
                                }
                            }
                        }
                    }

                    .category {
                        margin-right : 20px;
                        padding-right : 20px;
                        border-right : 1px solid ${colors.border3};
                        h6 {
                            color : ${colors.black2};
                            font-weight: 600;
                            text-transform: uppercase;
                            margin-bottom: 5px;

                            @media(max-width: 767px) {
                                font-size : 14px;
                            }
                        }
                        p {
                            font-size : 15px;
                            color : ${colors.text3};
                            font-weight: 500;

                            @media(max-width: 767px) {
                                font-size : 14px;
                            }
                        }
                    }

                    .rating {
                        margin-right : 20px;
                        padding-right : 20px;
                        border-right : 1px solid ${colors.border3};
                        h6 {
                            color : ${colors.black2};
                            font-weight: 600;
                            text-transform: uppercase;
                            margin-bottom: 5px;

                            @media(max-width: 767px) {
                                font-size : 14px;
                            }
                        }
                        ul {
                            li {
                                margin-right: 1px;
                                i {
                                    font-size: 16px;
                                    color: ${colors.yellow};
                                }
                                &:last-child {
                                    font-size : 15px;
                                    color : ${colors.text3};
                                    font-weight: 500;
                                    margin-left: 5px;

                                    @media(max-width: 767px) {
                                        font-size : 14px;
                                    }
                                }
                            }
                        }
                    }

                    .price {
                        h6 {
                            color : ${colors.black2};
                            font-weight: 600;
                            text-transform: uppercase;
                            margin-bottom: 5px;

                            @media(max-width: 767px) {
                                font-size : 14px;
                            }
                        }
                        p {
                            font-size : 15px;
                            color : ${colors.text3};
                            font-weight: 500;

                            @media(max-width: 767px) {
                                font-size : 14px;
                            }
                        }
                    }
                }

                @media(max-width: 480px) {
                    display : none;
                }
            }
            .course-details-main {
                .course-details-item {
                    margin-bottom: 30px;
                    h5 {
                        color: ${colors.black2};
                        font-weight: 600;
                        padding-bottom: 10px;
                        margin-bottom: 15px;
                        position: relative;
                        &:before {
                            position: absolute;
                            content: "";
                            background: ${colors.red};
                            width: 50px;
                            height: 2px;
                            bottom: 0;
                            left: 0;
                        }
                    }
                    p {
                        font-size: 15px;
                        color: ${colors.text3};
                        line-height: 26px;
                        margin-bottom: 10px;
                    }
                    ul.course-details-feature {
                        li {
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            color: ${colors.text2};
                            margin-bottom: 10px;
                            i {
                                font-size: 18px;
                                color: ${colors.red};
                                margin-right: 10px;
                            }
                            span {
                                font-weight: 600;
                                color: ${colors.black2};
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }
            .course-details-banner {
                margin-bottom: 40px;
                img {
                    border-radius : 5px;
                }
            }
            .course-tab-list {
                .nav {
                    display: inline-block;
                    border-radius: 5px;
                    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
                    margin-bottom: 35px;
                    .nav-item {
                        display: inline-block;
                        a.nav-link {
                            font-size: 14px;
                            color: ${colors.black2};
                            font-weight: 500;
                            text-transform : uppercase;
                            padding: 12px 30px 10px;
                            border-radius: 5px;

                            @media(max-width: 991px) {
                                padding: 12px 16px 9px;
                            }
                        }
                        a.nav-link.active {
                            background : ${colors.red_bg};
                            color : #ffffff;
                        }
                    }
                }
                .tab-content {
                    .overview-tab {
                        h5 {
                            color: ${colors.black2};
                            font-weight: 600;
                            padding-bottom: 10px;
                            margin-bottom: 20px;
                            position: relative;
                            &:before {
                                position: absolute;
                                content: "";
                                background: ${colors.red};
                                width: 50px;
                                height: 2px;
                                bottom: 0;
                                left: 0;
                            }

                            @media(max-width: 575px) {
                                font-size : 17px;
                            }                            
                        }
                        p {
                            font-size: 15px;
                            color: ${colors.text2};
                            line-height: 25px;

                            @media(max-width: 575px) {
                                font-size : 14px;
                            }
                        }

                        .course-desc {
                            margin-bottom: 40px;
                        }

                        .course-feature {
                            margin-bottom: 40px;
                            ul {
                                margin-top: 20px;
                                li {
                                    font-size : 14px;
                                    color: ${colors.text3};
                                    line-height : 25px;
                                    margin-bottom : 10px;
                                    i {
                                        font-size : 20px;
                                        color: ${colors.red};
                                        float: left;
                                        height: 40px;
                                        line-height: 27px;
                                        margin-right: 10px;
                                    }
                                    &:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                        .course-learn {
                            margin-bottom: 40px;
                            ul {
                                margin-top: 20px;
                                li {
                                    font-size: 14px;
                                    color: ${colors.text3};
                                    line-height: 25px;
                                    margin-bottom: 15px;
                                    i {
                                        float: left;
                                        color: ${colors.red};
                                        border: 1px solid ${colors.border3};
                                        width: 35px;
                                        height: 35px;
                                        border-radius: 50%;
                                        text-align: center;
                                        padding-top: 9px;
                                        margin-top: 8px;
                                        margin-right: 15px;
                                    }
                                    &:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                        .course-share {
                            ul.social {
                                margin-top: 30px;
                                li {
                                    a {
                                        text-align: center;
                                        position  : relative;
                                        height    : 18px;
                                        display   : inline-block;

                                        &:before {
                                            content           : "";
                                            position          : absolute;
                                            border-width      : 9px 17px;
                                            border-style      : solid;
                                            border-top-color  : transparent;
                                            border-right-color: transparent;
                                            border-left-color : transparent;
                                            top               : -18px;
                                            left              : 0;
                                            z-index           : 1;
                                            transition : all 0.2s ease;
                                        }

                                        &:after {
                                            content            : "";
                                            position           : absolute;
                                            border-width       : 9px 17px;
                                            border-style       : solid;
                                            border-right-color : transparent;
                                            border-bottom-color: transparent;
                                            border-left-color  : transparent;
                                            bottom             : -18px;
                                            left               : 0;
                                            z-index            : 1;
                                            transition : all 0.2s ease;
                                        }

                                        i {
                                            font-size: 14px;
                                            color    : #ffffff;
                                            width    : 34px;
                                        }

                                        &:hover {
                                            background-color: ${colors.red} !important;

                                            &:before {
                                                border-bottom-color: ${colors.red} !important;
                                            }

                                            &:after {
                                                border-top-color: ${colors.red} !important;
                                            }
                                        }
                                    }

                                    &:nth-child(1) {
                                        a {
                                            background-color: #4267B2;

                                            &:before {
                                                border-bottom-color: #4267B2;
                                            }

                                            &:after {
                                                border-top-color: #4267B2;
                                            }
                                        }
                                    }

                                    &:nth-child(2) {
                                        a {
                                            background-color: #1DA1F2;

                                            &:before {
                                                border-bottom-color: #1DA1F2;
                                            }

                                            &:after {
                                                border-top-color: #1DA1F2;
                                            }
                                        }
                                    }

                                    &:nth-child(3) {
                                        a {
                                            background-color: #2867B2;

                                            &:before {
                                                border-bottom-color: #2867B2;
                                            }

                                            &:after {
                                                border-top-color: #2867B2;
                                            }
                                        }
                                    }

                                    &:nth-child(4) {
                                        a {
                                            background-color: #DD1343;

                                            &:before {
                                                border-bottom-color: #DD1343;
                                            }

                                            &:after {
                                                border-top-color: #DD1343;
                                            }
                                        }
                                    }

                                    &:nth-child(5) {
                                        a {
                                            background-color: #ea4c89;

                                            &:before {
                                                border-bottom-color: #ea4c89;
                                            }

                                            &:after {
                                                border-top-color: #ea4c89;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .curriculum-tab {
                        .course-curriculum {
                            margin-bottom: 40px;
                            h5 {
                                color: ${colors.black2};
                                font-weight: 600;
                                padding-bottom: 10px;
                                margin-bottom: 20px;
                                position: relative;
                                &:before {
                                    position: absolute;
                                    content: "";
                                    background: ${colors.red};
                                    width: 50px;
                                    height: 2px;
                                    bottom: 0;
                                    left: 0;
                                }

                                @media(max-width: 575px) {
                                    font-size : 17px;
                                }  
                            }
                            p {
                                font-size: 15px;
                                color: ${colors.text2};
                                line-height: 25px;

                                @media(max-width: 575px) {
                                    font-size : 14px;
                                }
                            }
                        }
                        .course-element {
                            h5 {
                                color: ${colors.black2};
                                font-weight: 600;
                                padding-bottom: 10px;
                                margin-bottom: 20px;
                                position: relative;
                                &:before {
                                    position: absolute;
                                    content: "";
                                    background: ${colors.red};
                                    width: 50px;
                                    height: 2px;
                                    bottom: 0;
                                    left: 0;
                                }

                                @media(max-width: 575px) {
                                    font-size : 17px;
                                }
                            }
                            .course-item {
                                margin-bottom: 10px;
                                button.course-button {
                                    border: none;
                                    background: transparent;
                                    margin-bottom: 15px;
                                    display: block;
                                    width: 100%;
                                    text-align : left;
                                    padding: 0;
                                    font-size : 18px;
                                    color: ${colors.black2};
                                    font-weight: 500;
                                    span {
                                        float: right;
                                        font-size: 14px;
                                        color: ${colors.text3};
                                        font-weight: 400;
                                    }
                                }

                                .course-content {
                                    max-height: 0;
                                    overflow  : hidden;
                                    transition: max-height 0.2s ease-in-out;
                                    ul {
                                        li {
                                            border-bottom : 1px solid ${colors.border3};
                                            margin-left: 25px;
                                            padding: 12px 0;
                                            span.play-icon {
                                                font-size : 14px;
                                                color: ${colors.text3};
                                                margin-right: 20px;
                                                i {
                                                    color: ${colors.red};
                                                    border: 1px solid ${colors.red};
                                                    font-size: 22px;
                                                    width: 30px;
                                                    height: 30px;
                                                    border-radius: 50%;
                                                    padding-left: 3px;
                                                    text-align: center;
                                                    line-height: 29px;
                                                    vertical-align: middle;
                                                    margin-right: 10px;
                                                }
                                            }
                                            span.lecture-title {
                                                font-size : 15px;
                                                color: ${colors.black2};

                                                @media(max-width: 575px) {
                                                    font-size : 14px;
                                                }
                                            }
                                            span.lecture-duration {
                                                float: right;
                                                font-size: 14px;
                                                color: ${colors.text3};
                                                line-height: 28px;
                                                font-weight: 400;
                                            }
                                        }
                                    }
                                }

                                .course-content.show {
                                    max-height: 100%;
                                    margin-bottom: 40px;
                                }

                                &:last-child {
                                    margin-bottom: 40px;
                                }
                            }
                        }
                    }

                    .instructor-tab {
                        h5 {
                            color: ${colors.black2};
                            font-weight: 600;
                            padding-bottom: 10px;
                            margin-bottom: 35px;
                            position: relative;
                            &:before {
                                position: absolute;
                                content: "";
                                background: ${colors.red};
                                width: 50px;
                                height: 2px;
                                bottom: 0;
                                left: 0;
                            }

                            @media(max-width: 575px) {
                                font-size : 17px;
                            }
                        }

                        .instructor-item {
                            margin-bottom: 30px;

                            .instructor-img {
                                img {
                                    border-radius : 5px;
                                }
                            }

                            .instructor-content {
                                position: relative;

                                .instructor-box {
                                    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
                                    padding   : 25px;
                                    background: #ffffff;
                                    border-radius : 5px;
                                    position: absolute;
                                    top     : 32px;
                                    left    : -11%;
                                    z-index : 1;

                                    .top-content {
                                        margin-bottom: 20px;

                                        .instructor-name {
                                            h6 {
                                                color      : ${colors.black2};
                                                font-weight: 600;
                                                text-transform: uppercase;
                                                margin-bottom: 12px;

                                                @media(max-width: 575px) {
                                                    font-size : 14px;
                                                }
                                            }
                                            p {
                                                font-size  : 14px;
                                                color      : ${colors.text3};
                                                font-weight: 500;
                                            }
                                        }
                                        .instructor-social {
                                            margin-top: 25px;
                                            ul.social {
                                                li {
                                                    a {
                                                        text-align: center;
                                                        position  : relative;

                                                        &:before {
                                                            content           : "";
                                                            position          : absolute;
                                                            border-width      : 8px 14px;
                                                            border-style      : solid;
                                                            border-top-color  : transparent;
                                                            border-right-color: transparent;
                                                            border-left-color : transparent;
                                                            top               : -16px;
                                                            left              : 0;
                                                            z-index           : 1;
                                                            transition : all 0.2s ease;
                                                        }

                                                        &:after {
                                                            content            : "";
                                                            position           : absolute;
                                                            border-width       : 8px 14px;
                                                            border-style       : solid;
                                                            border-right-color : transparent;
                                                            border-bottom-color: transparent;
                                                            border-left-color  : transparent;
                                                            bottom             : -16px;
                                                            left               : 0;
                                                            z-index            : 1;
                                                            transition : all 0.2s ease;
                                                        }

                                                        i {
                                                            font-size: 13px;
                                                            color    : #ffffff;
                                                            width    : 28px;
                                                        }

                                                        &:hover {
                                                            background-color: ${colors.red} !important;

                                                            &:before {
                                                                border-bottom-color: ${colors.red} !important;
                                                            }

                                                            &:after {
                                                                border-top-color: ${colors.red} !important;
                                                            }
                                                        }
                                                    }

                                                    &:nth-child(1) {
                                                        a {
                                                            background-color: #4267B2;

                                                            &:before {
                                                                border-bottom-color: #4267B2;
                                                            }

                                                            &:after {
                                                                border-top-color: #4267B2;
                                                            }
                                                        }
                                                    }

                                                    &:nth-child(2) {
                                                        a {
                                                            background-color: #1DA1F2;

                                                            &:before {
                                                                border-bottom-color: #1DA1F2;
                                                            }

                                                            &:after {
                                                                border-top-color: #1DA1F2;
                                                            }
                                                        }
                                                    }

                                                    &:nth-child(3) {
                                                        a {
                                                            background-color: #2867B2;

                                                            &:before {
                                                                border-bottom-color: #2867B2;
                                                            }

                                                            &:after {
                                                                border-top-color: #2867B2;
                                                            }
                                                        }
                                                    }

                                                    &:nth-child(4) {
                                                        a {
                                                            background-color: #DD1343;

                                                            &:before {
                                                                border-bottom-color: #DD1343;
                                                            }

                                                            &:after {
                                                                border-top-color: #DD1343;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    .instructor-desk {
                                        p {
                                            font-size : 15px;
                                            color      : ${colors.text2};
                                            line-height: 25px;

                                            @media(max-width: 575px) {
                                                font-size : 14px;
                                            }
                                        }
                                    }
                                }
                            }

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .review-tab {
                        .review-comments {
                            margin-bottom: 40px;
                            h5 {
                                color: ${colors.black2};
                                font-weight: 600;
                                padding-bottom: 10px;
                                margin-bottom: 35px;
                                position: relative;
                                &:before {
                                    position: absolute;
                                    content: "";
                                    background: ${colors.red};
                                    width: 50px;
                                    height: 2px;
                                    bottom: 0;
                                    left: 0;
                                }

                                @media(max-width: 575px) {
                                    font-size : 17px;
                                }
                            }
                            .comment-box {
                                border-bottom: 1px solid ${colors.border1};
                                padding-bottom: 20px;
                                margin-bottom: 25px;
                                .comment-image {
                                    img {
                                        max-width : 100px;
                                        border-radius : 5px;
                                        margin-right : 20px;
                                    }
                                }
                                .comment-content {
                                    .content-title {
                                        .comment-writer {
                                            h6 {
                                                color: ${colors.black2};
                                                font-weight: 600;
                                                margin-bottom : 10px;

                                                @media(max-width: 575px) {
                                                    font-size : 14px;
                                                }
                                            }
                                            p {
                                                font-size : 12px;
                                                color: ${colors.text3};
                                                margin-bottom: 5px;
                                            }
                                            ul {
                                                margin-bottom: 8px;
                                                li {
                                                    margin-right: 1px;
                                                    i {
                                                        font-size: 16px;
                                                        color: ${colors.yellow};
                                                    }
                                                    &:last-child {
                                                        font-size: 13px;
                                                        color: ${colors.text2};
                                                        margin-left: 5px;
                                                    }
                                                }
                                            }
                                        }
                                        .reply-btn {
                                            button {
                                                font-size : 14px;
                                                color: ${colors.red};
                                                background : transparent;
                                                border : 1px solid ${colors.border3};
                                                font-weight: 500;
                                                border-radius: 25px;
                                                padding: 4px 12px 3px;
                                                margin-top : 10px;
                                                i {
                                                    font-size: 17px;
                                                    vertical-align: text-top;
                                                }
                                                &:hover {
                                                    color : #ffffff;
                                                    background : ${colors.red_bg};
                                                    border-color : ${colors.red};
                                                }
                                            }
                                        }
                                    }
                                    .comment-desc {
                                        p {
                                            font-size: 14px;
                                            color: ${colors.text3};
                                            line-height: 25px;
                                        }
                                    }
                                }
                                &:last-child {
                                    border-bottom : none;
                                    padding-bottom : 0;
                                    margin-bottom : 0;
                                }
                            }
                        }

                        .review-form {
                            h5 {
                                color: ${colors.black2};
                                font-weight: 600;
                                padding-bottom: 10px;
                                margin-bottom: 25px;
                                position: relative;
                                &:before {
                                    position: absolute;
                                    content: "";
                                    background: ${colors.red};
                                    width: 50px;
                                    height: 2px;
                                    bottom: 0;
                                    left: 0;
                                }

                                @media(max-width: 575px) {
                                    font-size : 17px;
                                }
                            }
                        }
                    }
                }
            }

            @media(max-width: 767px) {
                margin-bottom: 40px;
            }
        }

        .single-details-sidbar {
            .course-details-feature {
                box-shadow: 0 8px 25px rgba(0,0,0,0.1);
                border-radius: 5px;
                padding: 15px 20px 20px;
                h5.title {
                    color: ${colors.black1};
                    font-weight: 600;
                    padding-bottom: 10px;
                    margin-bottom: 20px;
                    position: relative;
                    &:before {
                        position: absolute;
                        content: "";
                        background: ${colors.red};
                        width: 50px;
                        height: 2px;
                        bottom: 0;
                        left: 0;
                    }

                    @media(max-width: 575px) {
                        font-size : 17px;
                    }
                }

                ul.feature-list {
                    margin-bottom: 20px;
                    li {
                        border-top: 1px dashed ${colors.border3};
                        padding: 12px 0;
                        font-size : 14px;
                        color : ${colors.black2};
                        font-weight: 500;
                        i {
                            font-size : 20px;
                            color: ${colors.red};
                            vertical-align: top;
                            margin-right : 2px;
                        }
                        span {
                            float : right;
                            font-size: 13px;
                            color: ${colors.text3};
                            font-weight: 400;
                            line-height: 20px;
                        }
                        &:first-child {
                            border-top : none;
                            padding-top : 0;
                        }
                        &:last-child {
                            padding-bottom : 0;
                        }
                    }
                }

                button.enroll-btn {
                    font-size: 16px;
                    color: #fff;
                    background: ${colors.red_bg};
                    display: inline-block;
                    width: 100%;
                    height: 40px;
                    font-weight : 500;
                    border : none;
                    padding: 9px;
                    border-radius: 5px;
                    &:hover {
                        background: ${colors.red_bg2};
                    }

                    @media(max-width: 575px) {
                        font-size : 14px;
                    }
                }

                @media(max-width: 1199px) {
                    padding: 12px 15px 15px;
                }
            }
        }

        @media(max-width: 767px) {
            padding: 20px 0 5px;
        }
    }

    .course-details-area .detail-list.detail-left li {
        justify-content: space-between;
        align-items: center;
    }

    .course-details-area .detail-list.detail-left li .detail-left-label {
        display: flex;
        align-items: center;
        gap: 12px;
        font-weight: 500;
        color: ${colors.black1};
    }

    .course-details-area .detail-list.detail-left li strong {
        margin-left: 0;
    }
`;
